
const URL = 'https://manage.julicy.com'     //测试
//const URL = 'http://manage.julicy.com'     //生产


//export const baseURL = 'http://192.168.3.206:8080/jlcy'
export const baseURL = `${URL}/jlcy`

// const JuLiUrl = 'http://www.julicy.com/admin'
const JuLiUrl = 'https://new.julicy.com/admin'

export const wtUrl = JuLiUrl
export const loginurl  = JuLiUrl
//http://new.julicy.com/admina
